module.exports = __webpack_public_path__ + "img/07.png";